// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchDOT_wrapper__2BrOv","dotNumberWrapper":"SearchDOT_dotNumberWrapper__2y5Bf","errorMessage":"SearchDOT_errorMessage__3rmRc"};